import React from 'react';
export interface TabItem {
  id: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
}
interface TabsProps {
  items: TabItem[];
  value: string;
  onValueChange: (id: string) => void;
  /**
   * - "pill": rounded pills, active = coral fill (default, used for content filters)
   * - "underline": bottom-border tabs (used for page-level section nav)
   */
  variant?: 'pill' | 'underline';
  className?: string;
  scrollable?: boolean;
}
export function Tabs({
  items,
  value,
  onValueChange,
  variant = 'pill',
  className = '',
  scrollable = false
}: TabsProps) {
  const wrapper = variant === 'underline' ? `flex items-center gap-6 border-b border-border ${scrollable ? 'overflow-x-auto' : ''} ${className}` : `flex items-center gap-2 ${scrollable ? 'overflow-x-auto pb-1' : 'flex-wrap'} ${className}`;
  return <div role="tablist" className={`${wrapper} ${scrollable ? 'hide-scrollbar' : ''}`} data-id="element-1154">
      {items.map(item => {
      const isActive = item.id === value;
      const className = variant === 'underline' ? `relative -mb-px pb-3 pt-1 text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-2 border-b-2 ${isActive ? 'border-coral text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}` : `inline-flex items-center gap-1.5 px-4 h-9 rounded-xl text-sm font-medium whitespace-nowrap transition-colors ${isActive ? 'bg-coral text-white' : 'bg-white border border-border text-foreground hover:bg-muted'}`;
      return <button key={item.id} type="button" role="tab" aria-selected={isActive} onClick={() => onValueChange(item.id)} className={className} data-id="element-1155">
            {item.icon}
            {item.label}
            {item.badge}
          </button>;
    })}
    </div>;
}